import { PagedResponseEmpty } from "@ofqual/portal-core/core/types";
import { combineReducers, AnyAction } from "redux";
import {
  LOADING_DATA_PORTAL_LOOKUP_LIST,
  LOADED_DATA_PORTAL_LOOKUP_LIST,
  UPDATED_DATA_PORTAL_LOOKUP_LIST,
  UPDATING_DATA_PORTAL_LOOKUP_LIST,
  LOADING_DATA_PORTAL_PREVIOUS_LIST,
  LOADED_DATA_PORTAL_PREVIOUS_LIST,
  UPDATING_DATA_PORTAL_PREVIOUS_LIST,
  UPDATED_DATA_PORTAL_PREVIOUS_LIST,
  ERROR_RETURN,
  FAILED_RETURN,
  SUCCESS_RETURN,
  RESET_SUBMISSION,
  SUBMIT_RETURN,
  SUBMIT_NIL_RETURN,
} from "./actions";

import { PendingReturnListState, SubmissionState } from "./state";

const dataPortalLookupListInitialState: PendingReturnListState = {
  status: "NOT_LOADED",
  response: [],
  hasData: false,
  updated: false,
  orgId: "",
};

const dataPortalLookupList = (
  state: PendingReturnListState = dataPortalLookupListInitialState,
  action: AnyAction
) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_DATA_PORTAL_LOOKUP_LIST:
      return {
        ...state,
        status: "LOADING",
        orgId: payload?.orgId || "",
      };
    case LOADED_DATA_PORTAL_LOOKUP_LIST:
      return {
        ...state,
        status: "LOADED",
        response: payload,
        hasData: true,
        updated: false,
      };

    case UPDATING_DATA_PORTAL_LOOKUP_LIST:
      return {
        ...state,
        status: "UPDATING",
      };

    case UPDATED_DATA_PORTAL_LOOKUP_LIST:
      return {
        ...state,
        status: "UPDATED",
        response: PagedResponseEmpty,
        hasData: false,
        updated: true,
      };
    default:
      return state;
  }
};

const dataPortalPreviousList = (
  state: PendingReturnListState = dataPortalLookupListInitialState,
  action: AnyAction
) => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_DATA_PORTAL_PREVIOUS_LIST:
      return {
        ...state,
        status: "LOADING",
      };
    case LOADED_DATA_PORTAL_PREVIOUS_LIST:
      return {
        ...state,
        status: "LOADED",
        response: payload,
        hasData: true,
        updated: false,
      };

    case UPDATING_DATA_PORTAL_PREVIOUS_LIST:
      return {
        ...state,
        status: "UPDATING",
      };

    case UPDATED_DATA_PORTAL_PREVIOUS_LIST:
      return {
        ...state,
        status: "UPDATED",
        response: PagedResponseEmpty,
        hasData: false,
        updated: true,
      };
    default:
      return state;
  }
};

const initialSubmissionState: SubmissionState = {
  submissions: []
};

const submissionState = (
  state: SubmissionState = initialSubmissionState,
  action: AnyAction
) => {
  const { type, payload } = action;
  const key = (!!payload && !!payload.collectionAoId && !!payload.templateId)
    ? `${payload.collectionAoId}-${payload.templateId}`
    : "NO_KEY"
  switch (type) {
    case ERROR_RETURN:
      return {
        ...state,
        submissions: [ 
          ...state.submissions.filter(x => x.key !== key),
          { key, status: "ERROR", message: "Please try again" }
        ]
      }
    case FAILED_RETURN:
      return {
        ...state,
        submissions: [ 
          ...state.submissions.filter(x => x.key !== key),
          { key, status: "INVALID", message: payload.message }
        ]
      }
    case SUCCESS_RETURN:
      return {
        ...state,
        submissions: [ 
          ...state.submissions.filter(x => x.key !== key),
          { key, status: "SUCCESS" }
        ]
      }
    case RESET_SUBMISSION:
      return {
        ...state,
        submissions: [ ...state.submissions.filter(x => x.key !== payload.key) ]
      }
    case SUBMIT_RETURN:
      return {
        ...state,
        submissions: [
          ...state.submissions.filter(x => x.key !== key),
          { key, status: "UPLOADED" }
        ]
      }
    case SUBMIT_NIL_RETURN:
      return {
        ...state,
        submissions: [
          ...state.submissions.filter(x => x.key !== key),
          { key, status: "NIL_RETURN_PENDING" }
        ]
      }
    default:
      return state;
  }
}

export const rootReducer = combineReducers({
  dataPortalLookupList,
  dataPortalPreviousList,
  submissionState,
});
